import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  activationErrorTitle: {
    defaultMessage: 'Store activation failed',
    description: 'Alert title when store activation for returns fails after all retry attempts',
    id: 'GHLPqD',
  },
  activationErrorFallback: {
    defaultMessage: 'Failed to activate store for returns.',
    description: 'Fallback error message when store activation fails with no server-provided message',
    id: 'yooNa7',
  },
});
